import { Component, OnInit } from '@angular/core';
import { Util } from 'modules/util';

declare const $: any;
declare interface RouteInfo {
  menuID: string;
  subMenuID: string;
  path: string;
  title: string;
  icon: string;
  class: string;
}

export const ROUTES: RouteInfo[] = [
  // Main Menu Items:
  { menuID: 'main', subMenuID: 'acpSub', path: '', title: 'Advance Care Planning', icon: 'icon-binoculars', class: '' },
  { menuID: 'main', subMenuID: 'reolSub', path: '', title: 'Recognise End of Life', icon: 'icon-puzzle-piece', class: '' },
  { menuID: 'main', subMenuID: 'pcnSub', path: '', title: 'Assess Palliative Care Needs', icon: 'icon-pencil', class: '' },
  { menuID: 'main', subMenuID: 'pcSub', path: '', title: 'Provide Palliative Care', icon: 'icon-list-ol', class: '' },
  { menuID: 'main', subMenuID: 'workSub', path: '', title: 'Work Together', icon: 'icon-ils', class: '' },
  { menuID: 'main', subMenuID: 'detSub', path: '', title: 'Respond to Deterioration', icon: 'icon-refresh', class: '' },
  { menuID: 'main', subMenuID: 'eolSub', path: '', title: 'Manage Dying', icon: 'icon-medkit', class: '' },
  { menuID: 'main', subMenuID: 'bereavementSub', path: '', title: 'Bereavement', icon: 'icon-heart', class: '' },
  { menuID: 'main', subMenuID: 'deathSub', path: '', title: 'Death Related Data', icon: 'pe-7s-ticket', class: '' },

  // Submenu Items:
  { menuID: 'acpSub', subMenuID: '', path: 'acp', title: 'Advance Care Plan Documentation', icon: '', class: '' },
  { menuID: 'acpSub', subMenuID: '', path: 'surrogate', title: 'Substitute Decision Maker', icon: 'pe-7s-pen', class: '' },
  { menuID: 'pcnSub', subMenuID: '', path: 'pcphasing', title: 'EOL Status', icon: 'pe-7s-clock', class: '' },
  { menuID: 'reolSub', subMenuID: '', path: 'spict', title: 'SPICT Utilisation', icon: 'pe-7s-way', class: '' },
  { menuID: 'pcSub', subMenuID: '', path: 'pcdoc', title: 'Palliative Care Plan Documentation', icon: 'pe-7s-copy-file', class: '' },
  { menuID: 'workSub', subMenuID: '', path: 'pcservice', title: 'Expert Palliative Care Input', icon: 'pe-7s-study', class: '' },
  { menuID: 'workSub', subMenuID: '', path: 'family', title: 'Family Conference', icon: 'pe-7s-users', class: '' },
  { menuID: 'detSub', subMenuID: '', path: 'hospitalisation', title: 'Hospitalisation', icon: 'pe-7s-clock', class: '' },
  { menuID: 'detSub', subMenuID: '', path: 'pcphasing', title: 'EOL Status', icon: 'pe-7s-clock', class: '' },
  { menuID: 'eolSub', subMenuID: '', path: 'eolman', title: 'EOL Dying Care', icon: 'pe-7s-hourglass', class: '' },
  { menuID: 'bereavementSub', subMenuID: '', path: 'bereavement', title: 'Bereavement', icon: 'pe-7s-drop', class: '' },
  { menuID: 'deathSub', subMenuID: '', path: 'death', title: 'Death and EOL Status', icon: 'pe-7s-ticket', class: '' },
  { menuID: 'deathSub', subMenuID: '', path: 'deathplace', title: 'Place of Death', icon: 'pe-7s-ticket', class: '' },

  // Other:
  { menuID: '', subMenuID: '', path: 'residenttable', title: 'Residents', icon: '', class: '' }
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor() { }

  // Given a menuID, this method returns the subset of routes from ROUTES which have the specified menuID.
  // args: menuID - 
  //         the menuID which will identify a route as a valid member of the returned subset
  //         colouring.
  // return: a subset of ROUTES having the specified menuID
  // note: a further restricted subset shall be returned when demo mode is enabled
  somePaths(menuID: string) {
    let routes: RouteInfo[] = null;
    if (Util.isInDemoMode()) {
      // routes = ROUTES.filter(menuitem => menuitem.menuID === menuID && (menuitem.subMenuID === "acpSub" || menuitem.subMenuID === ""));
      routes = ROUTES.filter(menuitem => menuitem.menuID === menuID);
    } else {
      routes = ROUTES.filter(menuitem => menuitem.menuID === menuID);
    }
    return routes;
  }

  ngOnInit() {
    // this.menuItems = ROUTES.filter(menuItem => menuItem);
    if (Util.isInDemoMode()) {

      for (let route of ROUTES) {
        if (route.menuID != "main" && (route.menuID != "acpSub")) {
          route.path = "demoMessage";
        }
      }
    }

  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };
}
